export const CHAT_SERVICE_UNAVAILABLE_MESSAGE =
  "Сервис временно недоступен, мы уже работаем над восстановлением функционала!";

function isNetworkFailure(message: string): boolean {
  const normalized = message.trim().toLowerCase();
  return (
    normalized === "failed to fetch" ||
    normalized === "networkerror when attempting to fetch resource." ||
    normalized === "network request failed" ||
    normalized.includes("network error") ||
    normalized.includes("load failed")
  );
}

function isAuthFailure(message: string): boolean {
  return message.trim().toLowerCase().startsWith("ошибка авторизации");
}

/** Сообщение для пользователя вместо технических ошибок fetch/авторизации */
export function getUserFacingChatError(error: unknown): string {
  if (error instanceof Error) {
    const message = error.message.trim();
    if (!message || isNetworkFailure(message) || isAuthFailure(message)) {
      return CHAT_SERVICE_UNAVAILABLE_MESSAGE;
    }
    return message;
  }

  return CHAT_SERVICE_UNAVAILABLE_MESSAGE;
}
